<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDeliveryType') }}</h1>
      <div class="form-container">
        <DeliveryTypeForm :data="relations.instance" @save="save"></DeliveryTypeForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import DeliveryTypeForm from "@/components/DeliveryTypeForm"

  export default {
    components: {
      DeliveryTypeForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'delivery_types', payload}).then(() =>
          this.$router.push({ name: 'deliveryTypes'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'delivery_types', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'deliveryTypes', path: 'deliveryTypes'},
          {name: 'editDeliveryType'}
        ]
      }
    }
  }
</script>